import { create } from "zustand";
import db from "../database";

const useConfigStore = create((set, get) => ({
  // State
  pricingRules: [],
  workflowRules: [],
  saleTypes: [],
  uoms: [],
  globalParams: null,
  posScanConfigs: [],
  loaded: false,

  // Actions
  loadPricingRules: async () => {
    try {
      const rules = await db.pricingRules.toArray();
      set({ pricingRules: rules });
    } catch (error) {
      console.error("Failed to load pricing rules:", error);
    }
  },

  loadWorkflowRules: async () => {
    try {
      const rules = await db.POSWorkFlowRules.toArray();
      set({ workflowRules: rules });
    } catch (error) {
      console.error("Failed to load workflow rules:", error);
    }
  },

  loadSaleTypes: async () => {
    try {
      const types = await db.posSaletypes.toArray();
      set({ saleTypes: types });
    } catch (error) {
      console.error("Failed to load sale types:", error);
    }
  },

  loadUoms: async () => {
    try {
      const uoms = await db.productUom.toArray();
      set({ uoms });
    } catch (error) {
      console.error("Failed to load UOMs:", error);
    }
  },

  setGlobalParams: (params) => set({ globalParams: params }),

  setPosScanConfigs: (configs) => set({ posScanConfigs: configs }),

  loadConfig: async () => {
    const { loadPricingRules, loadWorkflowRules, loadSaleTypes, loadUoms } = get();
    await Promise.all([
      loadPricingRules(),
      loadWorkflowRules(),
      loadSaleTypes(),
      loadUoms(),
    ]);
    set({ loaded: true });
  },

  // Selectors
  getPricingRuleById: (id) => get().pricingRules.find((r) => r.mPricingrulesId === id),

  getWorkflowRule: (ruleId) => get().workflowRules.find((r) => r.cwrRulesId === ruleId),

  getSaleType: (id) => get().saleTypes.find((t) => t.cwrSaletypeId === id),
}));

export default useConfigStore;
